
const COLORS = {
    main: '#5459F3',
    grey: '#B1B1B1',
    accent: '#5459F3'
}

export default COLORS;